import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import styles from './styles.module.scss';

import apiNotFound from '../../api/NotFound';
import LinkLang from '../../components/Wraps/LinkLang';

import Config, { spanish } from '../../config/config';

const NotFound = () => {
  const [content, setContent] = useState(null);
  useEffect(async () => {
    setContent(await apiNotFound.getContent());
  }, []);
  return (
    <div className={styles.container}>
      <Helmet title={spanish ? 'Sin Resultados' : 'Not Found'} />
      <div className={styles.image}>
        <img
          src={Config.cdn.cdn_path + content?.Image?.url}
          alt={content?.TitleSpanish}
        />
      </div>
      <h2 className={styles.title}>
        {spanish ? content?.TitleSpanish : content?.TitleEnglish}
      </h2>
      <div className={styles.button}>
        <LinkLang to="/" className="btn btn-white">
          {spanish ? content?.ButtonSpanish : content?.ButtonEnglish}
        </LinkLang>
      </div>
    </div>
  );
};

export default NotFound;
